﻿import intlTelInput from 'intl-tel-input';
import utils from 'intl-tel-input/build/js/utils';

const belgium = '1728';
const belgische = '2023';
const married = '1065';
const livingTogether = '1071';
const divorced = '1068';

document.addEventListener('alpine:init', () => {
	Alpine.data('payrollForm', () => ({
		// step 1
		foreignersForm:false, 
		nationality:'',
		maritalStatus: '',
		legalAddressCountry: '',
		hasOtherAddress: false,
		actualAddressCountry: '',
		 get legalAddressInBelgium() {
			return this.legalAddressCountry === belgium;
		},
		get actualAddressInBelgium() {
			return this.actualAddressCountry === belgium;
		},
		get showPartnerFields() {
			return this.maritalStatus === married
				|| this.maritalStatus === livingTogether
				|| this.maritalStatus === divorced;
		},
		// step 2
		iban: '',
		isDisabled: false,
		isStudent:false, 
		selectedOption:'', 
		noExistingProject:false,
		klant:'',
		IdFrontName:"",
		IdBackName:"",
		get shouldShowBIC() {
			return this.iban.length > 0 && this.iban.toUpperCase().startsWith('BE') === false;
		},
		changeOtherVerblijfsAdresLandId (event) {
			this.actualAddressCountry = event.target.value;
		},
		validateFile(event, fieldName) {
			let file = event.target.files[0];
			let filename = file.name
			
			let maxSize = 1000000;
			let maxWidth = 1024; // Max width for resizing
			let maxHeight = 1024; // Max height for resizing
		
			if (!file) return;
			
			if (file.size > maxSize) {
				// Resize image before uploading
				let reader = new FileReader();
				reader.readAsDataURL(file);
		
				reader.onload = (e) => {
					let img = new Image();
					img.src = e.target.result;
		
					img.onload = () => {
						let canvas = document.createElement('canvas');
						let ctx = canvas.getContext('2d');
		
						let width = img.width;
						let height = img.height;
		
						// Resize logic (maintains aspect ratio)
						if (width > maxWidth || height > maxHeight) {
							if (width > height) {
								height *= maxWidth / width;
								width = maxWidth;
							} else {
								width *= maxHeight / height;
								height = maxHeight;
							}
						}
		
						canvas.width = width;
						canvas.height = height;
						ctx.drawImage(img, 0, 0, width, height);
		
						// Convert canvas to blob and create new file
						canvas.toBlob((blob) => {
							let resizedFile = new File([blob], file.name, {
								type: 'image/jpeg',
								lastModified: Date.now()
							});
		
							if (resizedFile.size > maxSize) {
								alert("File is too large! Please upload a smaller image.");
								event.target.value = "";
								this[fieldName] = "";
								sessionStorage.removeItem(fieldName);
							} else {
								this.uploadResizedFile(resizedFile,event.target, fieldName);
							}
						}, 'image/jpeg', 0.7); // Adjust quality (0.7 = 70%)
					};
				};
			} else {
				this.updateFileName(event, fieldName);
			}
		},
		uploadResizedFile(file, inputElement, fieldName) {
			let dataTransfer = new DataTransfer();
			dataTransfer.items.add(file);			

			if (inputElement) {
				inputElement.files = dataTransfer.files; // Assign the new file to the input field
				this[fieldName] = file.name;
				sessionStorage.setItem(fieldName, file.name);
			} else {
				console.error(`Input field not found for fieldName: ${fieldName}`);
			}
		},
		
		updateFileName(event, fieldName) {
            const file = event.target.files[0];
            const fileName = file ? file.name : 'No file selected';
            this[fieldName] = fileName;
            sessionStorage.setItem(fieldName, fileName);
        },
		setForeignersFormFalseWhenBelgium(event){
			const nationality = event.target.value
			if(nationality === belgische){
				this.foreignersForm = false
			}
		},
		deleteSessionStorage(){
			sessionStorage.clear();
		},
		
		init() {
			intlTelInput(this.$refs.gsmNr, {
				utilsScript: utils,
				autoInsertDialCode: true,
				nationalMode: false,
				separateDialCode: true,
				preferredCountries: ['be'],
				hiddenInput: this.$refs.gsmNr.name,
				initialCountry: this.$refs.gsmNr.value !== '' ? undefined : 'BE'
				}
			);
			this.IdFrontName = sessionStorage.getItem('IdFrontName') || '';
			this.IdBackName = sessionStorage.getItem('IdBackName') || '';
			this.$refs.gsmNr.name = ''; // intlTelInput generates a new (hidden) input with the same name. 
			this.maritalStatus = document.querySelector('[name="FiscaleSituatieId"]')?.value;
			this.legalAddressCountry = document.querySelector('[name="WettelijkAdresLandId"]')?.value;
			this.hasOtherAddress = document.querySelector('[name="OtherVerblijfsAdres"]')?.checked;
			this.iban = document.querySelector('[name="IBAN"]')?.value;
			this.isStudent = document.querySelector('[name="Student"]')?.checked;
			this.noExistingProject = document.querySelector('[name="GeenBestaandeOpdracht"]')?.checked;
			this.foreignersForm = document.querySelector('[name="HeeftGeenRijksregisternummer"]')?.checked;
			this.nationality = document.querySelector('[name="NationaliteitId"]')?.value;
			this.actualAddressCountry = document.querySelector('[name="VerblijfsAdresLandId"]')?.value;
			this.selectedOption = document.querySelector('[name="AfhoudingBedrijfsvoorheffingId"]')?.value;
			this.klant = document.querySelector('[name="Organisatienaam"]')?.value;

			intlTelInput(this.$refs.gsmNrOverview, {
				utilsScript: utils,
				autoInsertDialCode: true,
				nationalMode: false,
				separateDialCode: true,
				preferredCountries: ['be'],
				hiddenInput: this.$refs.gsmNrOverview.name,
				initialCountry: this.$refs.gsmNrOverview.value !== '' ? undefined : 'BE'
			});
			this.$refs.gsmNrOverview.name = ''; // intlTelInput generates a new (hidden) input with the same name. 

		},
		
		
	}))
});

